import EmployeePanel from "./employeePanel.container";

export default EmployeePanel;
